export default __webpack_public_path__ + "static/media/panier.12636aff.svg";